import React, { type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button, { LoadingButton } from '@atlaskit/button';
import ModalDialog, {
	ModalBody,
	ModalTitle,
	ModalHeader,
	ModalFooter,
} from '@atlaskit/modal-dialog';
import { ViewTracker } from '@atlassian/jira-analytics-web-react/src';
import { ShortcutScope } from '@atlassian/jira-common-components-keyboard-shortcuts';
import { useIntl } from '@atlassian/jira-intl';
import type {
	FormError,
	FieldErrors,
} from '@atlassian/jira-servicedesk-knowledge-services/src/types';

import CreateCategoryForm from './create-category-form';
import messages from './messages';

type KnowledgeHubCreateCategoryStatelessProps = {
	isSubmitting: boolean;
	isDisabled: boolean;
	formValues: {
		name: string;
		description: string;
	};
	formError?: FormError;
	fieldErrors?: FieldErrors;
	onChange: (field: string, value: string) => void;
	onClose: () => void;
	onSubmit: (e: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

const KnowledgeHubCreateCategoryStateless = (props: KnowledgeHubCreateCategoryStatelessProps) => {
	const { formatMessage } = useIntl();
	const {
		isSubmitting = false,
		isDisabled = false,
		formValues,
		onChange,
		onClose,
		onSubmit,
		formError,
		fieldErrors,
	} = props;

	return (
		<ShortcutScope>
			<ModalDialog onClose={onClose} width="small">
				<ModalHeader>
					<ModalTitle>{formatMessage(messages.title)}</ModalTitle>
				</ModalHeader>

				<ModalBody>
					<ViewTracker />
					<CreateCategoryForm
						formValues={formValues}
						onChange={onChange}
						onSubmit={onSubmit}
						formError={formError}
						fieldErrors={fieldErrors}
						isDisabled={isSubmitting}
					/>
				</ModalBody>
				<ModalFooter>
					<LoadingButton
						appearance="primary"
						onClick={onSubmit}
						isLoading={isSubmitting}
						isDisabled={isDisabled}
					>
						{formatMessage(messages.createAction)}
					</LoadingButton>
					<Button onClick={onClose}>{formatMessage(messages.cancelAction)}</Button>
				</ModalFooter>
			</ModalDialog>
		</ShortcutScope>
	);
};

export default KnowledgeHubCreateCategoryStateless;
